import React from 'react'
import { Field } from 'rc-field-form'
import './FormItem.css'

const FormItem = ({ children, validateTrigger = 'onBlur', ...props }) => {
  return (
    <Field validateTrigger={validateTrigger} {...props}>
      {(control, meta) => (
        <div className="form-item">
          {React.cloneElement(children, { error: meta.errors.length, ...control })}
          <div className="form-item-meta">{meta.errors.length ? meta.errors[0] : ''}</div>
        </div>
      )}
    </Field>
  )
}

export default FormItem
